import confetti from "canvas-confetti";

// A short, on-brand (oxblood / gold / cream) confetti burst for happy moments.
// Respects the user's reduced-motion preference.
export function celebrate() {
  if (typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
  const colors = ["#4A0000", "#B08D57", "#FBFAF7"];
  confetti({ particleCount: 70, spread: 72, startVelocity: 42, origin: { x: 0.5, y: 0.72 }, colors, scalar: 0.9, ticks: 160, zIndex: 9999 });
  setTimeout(
    () => confetti({ particleCount: 40, spread: 100, startVelocity: 28, origin: { x: 0.5, y: 0.78 }, colors, scalar: 0.8, ticks: 140, zIndex: 9999 }),
    130
  );
}
